import cn from 'classnames';
import { useCallback } from 'react';

import { Burger, LogoDark } from '@webapp/common/assets/icons';
import { Nav } from '@webapp/common/components/nav';
import { Select } from '@webapp/common/components/select';
import { CssUiComponent } from '@webapp/common/components/survey-custom';
import { useClickOutside } from '@webapp/common/hooks/use-click-outside';
import { useToggle } from '@webapp/common/hooks/use-toggle';
import { ColorScheme, stopEvent } from '@webapp/common/lib/ui';

import { HeaderMenu } from './header-menu';
import { headerOpportunitiesOptions } from './helps';

import css from './header.css';

export const Header: FC<{
    className?: string;
    mode: ColorScheme;
    logoLink: string;
    isLanding?: boolean;
    nextRouter?: { asPath: string };
}> = ({ className, logoLink, mode, isLanding, nextRouter }) => {
    const { enabled: navActive, off: hideNav, toggle: toggleNav } = useToggle(false);

    const handleClickBurger = useCallback(
        (e: ReactMouseEvent): void => {
            stopEvent(e);
            toggleNav();
        },
        [toggleNav],
    );

    const outsideRef = useClickOutside(hideNav);

    return (
        <div className={CssUiComponent.NO_PRINT} ref={outsideRef}>
            <Nav nextRouter={nextRouter} active={navActive} onClose={handleClickBurger} />
            <header
                id='header'
                className={cn(css.header, className, {
                    [css.dark]: mode === ColorScheme.DARK,
                    [css.light]: mode === ColorScheme.LIGHT,
                    [css.headerLanding]: isLanding,
                })}
            >
                <div className={css.container}>
                    <div className={css.logo}>
                        <a href={logoLink} title='testograf'>
                            <LogoDark />
                        </a>
                    </div>
                    {isLanding && (
                        <div className={cn(css.menu, css.menuLanding)}>
                            <div className={css.item}>
                                <a className={css.link} href='/ru/respondent-panel'>
                                    Панель
                                </a>
                            </div>
                            <div className={css.item}>
                                <Select
                                    classNames={{ option: css.option, placeholder: css.link, control: css.link }}
                                    options={headerOpportunitiesOptions}
                                    placeholder='Возможности'
                                    view='transparent'
                                    stretchMenuToLongestOption={true}
                                    classNamePrefix='opportunities-select'
                                    unselected={true}
                                />
                            </div>
                            <div className={css.item}>
                                <a className={css.link} href='/ru/templates'>
                                    Шаблоны
                                </a>
                            </div>
                            <div className={css.item}>
                                <a className={css.link} href='/ru/pricing-plans'>
                                    Тарифы
                                </a>
                            </div>
                        </div>
                    )}
                    <div className={cn(css.menu, css.menuAuth)}>
                        <HeaderMenu isLanding={isLanding} />
                        <div className={css.burger}>
                            <Burger className={css.btn} onClick={handleClickBurger} />
                        </div>
                    </div>
                </div>
            </header>
        </div>
    );
};
